import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const KlipfolioShape = {
  api_key: Yup.string().label("API Key").min(40).max(40).required(),
  data_source_name: Yup.string().label("Data Source Name").max(200).required(),
};

export interface KlipfolioInput {
  api_key: string;
  data_source_name: string;
}

yupResolver<KlipfolioInput>(Yup.object().shape(KlipfolioShape));
